import React from "react";
import styled from "styled-components";
import SunSvg from "../assets/images/sun.svg";
import MoonSvg from "../assets/images/moon.svg";

export const Switch = ({
  styles,
  isToggled,
  onToggle,
  showThemeIcons,
  ariaLabel,
}: {
  styles?: React.CSSProperties;
  isToggled: boolean;
  onToggle: () => void;
  showThemeIcons?: boolean;
  ariaLabel?: string;
}): JSX.Element => {
  return (
    <LabelStyles style={styles}>
      <InputStyles
        type="checkbox"
        checked={isToggled}
        onChange={onToggle}
        aria-label={
          showThemeIcons
            ? "Switch input to toggle between light theme and dark theme"
            : ariaLabel
        }
      />
      <SpanStyles />
      {showThemeIcons && (
        <>
          <SunImgStyles src={SunSvg} />
          <MoonImgStyles src={MoonSvg} />
        </>
      )}
    </LabelStyles>
  );
};
// switch
const LabelStyles = styled.label`
  position: relative;
  display: inline-block;
  width: 2.4rem;
  height: 1.2rem;
`;
// checkbox
const InputStyles = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + span:before {
    transform: translateX(1rem);
  }
`;
// slider
const SpanStyles = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${(props) => props.theme.colours.foreground};
  border-radius: ${(props) => props.theme.borderRadius.switch};
  cursor: pointer;
  &:before {
    z-index: 10;
    position: absolute;
    content: "";
    left: 0.3rem;
    bottom: 0.2rem;
    height: 0.8rem;
    width: 0.8rem;
    background: ${(props) => props.theme.colours.background};
    border-radius: ${(props) => props.theme.borderRadius.circle};
    transition: 0.5s;
  }
`;
const SunImgStyles = styled.img`
  position: absolute;
  left: 0.3rem;
  bottom: 0.2rem;
  height: 0.8rem;
  width: 0.8rem;
`;
const MoonImgStyles = styled.img`
  position: absolute;
  right: 0.3rem;
  bottom: 0.2rem;
  height: 0.8rem;
  width: 0.8rem;
`;
export default Switch;
